<template>
  <div ref="container">
    <div class="coupon-list" v-if="couponsList.length > 0">
      <div
        class="item acea-row row-center-wrapper"
        v-for="(item, index) in couponsList"
        :key="index"
      >
        <div
          class="money"
          :class="
            item.status === 2 ||
            (item.remainCount <= 0 && item.userStatus !== 1)
              ? 'moneyGray'
              : ''
          "
        >
          <div>
            <span class="num"
              >{{ item.couponPrice
              }}<span class="co-integral" v-if="item.couponType === 1"
                >积分</span
              ><span class="co-integral" v-else>折</span>
            </span>
          </div>
          <div class="pic-num" v-if="item.condition > 0">
            满{{ item.condition
            }}<span v-if="item.conditionType === 1">积分</span
            ><span v-else>件</span>可用
          </div>
          <div class="pic-num" v-else>
            无门槛
          </div>
        </div>
        <div class="text">
          <div class="condition line1">
            <span>{{ item.couponTitle }}</span>
          </div>
          <div class="data acea-row row-between-wrapper">
            <div v-if="item.status === 2">
              {{ item.collectionStartTime }}开抢
            </div>
            <div v-else-if="item.couponTime && item.couponTime > 0">
              领券后{{ item.couponTime }}内有效
            </div>
            <div v-else>
              <div>
                {{ item.startTime }}
              </div>
              <div>
                {{ item.endTime }}
              </div>
            </div>
            <div
              class="bnt bg-color-red"
              @click="receiveCoupon(item.id, index)"
              v-if="item.userStatus === 0"
            >
              立即领取
            </div>
            <div
              class="bnt bg-color-red"
              @click="toUse(item.id, index)"
              v-else-if="item.userStatus === 1"
            >
              去使用
            </div>
            <div class="bnt gray" v-else-if="item.userStatus === 3">
              已达领取上限
            </div>
          </div>
          <div class="data1">
            <div v-if="item.sharePreferential" class="acea-row">
              <span v-if="item.sharePreferential.indexOf('优惠券') >= 0"
                >可叠加使用<span v-if="item.sharePreferential !== '优惠券'"
                  >，</span
                ></span
              >
              <span
                v-if="
                  item.sharePreferential.indexOf('限时折扣') >= 0 &&
                    item.sharePreferential.indexOf('满减/送') >= 0
                "
                >可与限时折扣、满减活动同享</span
              >
              <span v-else-if="item.sharePreferential.indexOf('限时折扣') >= 0"
                >可与限时折扣活动同享</span
              >
              <span v-else-if="item.sharePreferential.indexOf('满减/送') >= 0"
                >可与满减活动同享</span
              >
            </div>
            <div v-if="item.restriction > 0" class="acea-row">
              每个用户限领{{ item.restriction }}张
            </div>
          </div>
          <div class="coupon-cion" :class="item.userStatus === 1 ? 'rd' : ''">
            <div class="notstart" v-if="item.status === 2"></div>
            <div
              class="alreadyreceived"
              v-else-if="item.userStatus === 1"
            ></div>
            <div
              class="outstock"
              v-else-if="item.remainCount <= 0 && !item.userStatus"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loadend" :loading="loading"></Loading>
    <!--暂无优惠券-->
    <div
      class="noCommodity"
      v-cloak
      v-if="couponsList.length === 0 && page > 1"
    >
      <div class="noPictrue">
        <img src="@assets/images/noCoupon.png" class="image" />
      </div>
    </div>
  </div>
</template>
<script>
import { getCoupon, receiveCoupon } from "@api/user";
import Loading from "@components/Loading";
import { dataFormatT } from "@utils";
export default {
  name: "CouponCentre",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      page: 1,
      limit: 10,
      couponsList: [],
      loading: false,
      loadend: false
    };
  },
  mounted: function() {
    this.getUseCoupons();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getUseCoupons();
    });
  },
  methods: {
    dataFormatT,
    receiveCoupon: function(id, index) {
      let that = this;
      let list = that.couponsList;
      receiveCoupon(id)
        .then(function() {
          list[index].userStatus = 1;
          that.$dialog.toast({ mes: "领取成功" });
        })
        .catch(function(res) {
          that.$dialog.toast({ mes: res.msg });
        });
    },
    toUse(id, index) {
      this.$router.push({ path: "/goods_list" });
    },
    getUseCoupons: function() {
      let that = this;
      if (that.loading) return;
      if (that.loadend) return;
      that.loading = true;
      let q = { page: that.page, limit: that.limit };
      getCoupon(q).then(res => {
        that.loading = false;
        that.couponsList.push.apply(that.couponsList, res.data);
        that.loadend = res.data.length < that.limit; //判断所有数据是否加载完成；
        that.page = that.page + 1;
      });
    }
  }
};
</script>

<!--<style scoped>-->
<!--.coupon-list .pic-num {-->
<!--color: #ffffff !important;-->
<!--font-size: 0.24rem !important;-->
<!--}-->
<!--</style>-->
